export default "/images/grey-down.svg?a7b8c41a00358ab86cd9c1124118f66d";